import styles from './IsolatedViews.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import AssetOwnerIsolatedView from './AssetOwnerIsolatedView/AssetOwnerIsolatedView';
import { useEffect } from 'react';
import { initialiseOwnerState } from 'client/store/isolatedViewsSlice/isolatedViewsSlice';
import { orderBy } from 'lodash';

export const dataTestIdBase = 'mapPage.menu.isolatedViews';

const IsolatedViews = () => {
    const assetsInAOIOwners = useSelector(state => state?.assetOwners?.data?.assetsInAOIOwners);
    const orderedAssetOwners = orderBy(assetsInAOIOwners, 'label', 'asc');
    const dispatch = useDispatch();

    // Initialise per-owner isolated view state when new owners load
    useEffect(() => {
        assetsInAOIOwners.forEach(owner => {
            dispatch(initialiseOwnerState(owner.dataProviderId));
        });
    }, [assetsInAOIOwners, dispatch]);

    return <div data-testid={`${dataTestIdBase}.assetOwners`}>
        {orderedAssetOwners.length > 0 && (
            <ul className={styles.assetOwnerList}>
                {orderedAssetOwners.map(owner => (
                    <li key={owner.dataProviderId}>
                        <AssetOwnerIsolatedView owner={owner} dataTestId={dataTestIdBase} />
                    </li>
                ))}
            </ul>
        )}
    </div>;
};

export default IsolatedViews;
